/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserPlaylistLibraryContentsInner } from './UserPlaylistLibraryContentsInner';
import {
    UserPlaylistLibraryContentsInnerFromJSON,
    UserPlaylistLibraryContentsInnerFromJSONTyped,
    UserPlaylistLibraryContentsInnerToJSON,
} from './UserPlaylistLibraryContentsInner';

/**
 * User's playlist library with support for folders and playlists
 * @export
 * @interface UserPlaylistLibrary
 */
export interface UserPlaylistLibrary {
    /**
     * Array of folders and playlist identifiers
     * @type {Array<UserPlaylistLibraryContentsInner>}
     * @memberof UserPlaylistLibrary
     */
    contents: Array<UserPlaylistLibraryContentsInner>;
}

/**
 * Check if a given object implements the UserPlaylistLibrary interface.
 */
export function instanceOfUserPlaylistLibrary(value: object): value is UserPlaylistLibrary {
    let isInstance = true;
    isInstance = isInstance && "contents" in value && value["contents"] !== undefined;

    return isInstance;
}

export function UserPlaylistLibraryFromJSON(json: any): UserPlaylistLibrary {
    return UserPlaylistLibraryFromJSONTyped(json, false);
}

export function UserPlaylistLibraryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPlaylistLibrary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contents': ((json['contents'] as Array<any>).map(UserPlaylistLibraryContentsInnerFromJSON)),
    };
}

export function UserPlaylistLibraryToJSON(value?: UserPlaylistLibrary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contents': ((value.contents as Array<any>).map(UserPlaylistLibraryContentsInnerToJSON)),
    };
}

